import { IconProps } from "./types";

export function IconCaretLeft({ size = 20 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <path
        d="m16 4-8 8 8 8"
        stroke={"currentColor"}
        strokeWidth={2}
        strokeLinejoin="round"
        fill={"none"}
      />
    </svg>
  );
}
